<template>
  <div>
    <el-dialog
      title="添加优惠券"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose"
    >
      <div class="card">
        <div class="col-lg-12 list-header fix-header clearfix">
          <div class="dsply-fix fix-header-item">
            <b-form-input
              v-model="q"
              class="w-190 m-r-10"
              size="sm"
              type="text"
              placeholder="请输入关键字"
            ></b-form-input>
            <b-button
              class="m-r-5"
              size="sm"
              variant="primary"
              @click="search()"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
        </div>
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px;"></th>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col">名称</th>
                  <th scope="col">类型</th>
                  <th scope="col">总库存</th>
                  <th scope="col">可用库存</th>
                  <th scope="col">发放量</th>
                  <th scope="col">核销量</th>
                  <th scope="col">所属商家</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="media-dialog-radio">
                    <b-form-radio
                      name="coupon_radio"
                      @change="checkCoupon(item)"
                    ></b-form-radio>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-300px white-inherit">{{ item.title }}</td>
                  <td>
                    <template v-if="item.couponType == 1">代金券</template>
                    <template v-if="item.couponType == 2">折扣券</template>
                    <template v-if="item.couponType == 3">通用券</template>
                  </td>
                  <td>{{ item.countNumber || "--" }}</td>
                  <td>{{ item.quantity || "--" }}</td>
                  <td>{{ item.grantNumber || "--" }}</td>
                  <td>{{ item.verifyNumber || "0" }}</td>
                  <td>{{ item.merchant.name || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <pagination
          :isBatch="false"
          ref="pageCoupon"
          @pageCallback="pageCallback"
        ></pagination>
        <app-list-loading ref="cloading"></app-list-loading>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import coupon from "../../../server/api/coupons";
import pagination from "@/components/pagination/pagination.vue";

export default {
  components: {
    pagination,
  },

  data() {
    return {
      pageParams: {
        page: 1,
        pageSize: 5,
      },
      q: "",
      selectItem: {},
      items: [],
      show: false,
    };
  },

  props: {},

  mounted() {},

  methods: {
    showModel() {
      this.items = [];
      this.selectItem = {};
      this.show = true;
      this.resetParams();
    },

    handleClose() {
      this.show = false;
    },

    //获取列表数据
    getList() {
      let pageParams = {
        page: this.pageParams.page,
        pageSize: this.pageParams.pageSize,
        "q%5Bmerchant_id%5D": JSON.parse(localStorage.chosedMedia).id,
        "q%5Bkeywords%5D": this.q,
      };
      coupon.list(pageParams).then((resp) => {
        console.log(resp);
        if (resp.code == 0) {
          if (this.$refs.cloading) {
            this.$refs.cloading.hide(resp.data.items);
          }
          if (resp.data && resp.data.items) {
            console.log(resp.data);
            let itemsData = resp.data.items;
            this.items = itemsData;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages,
              //全部有几页
            };
            if (this.$refs.pageCoupon) {
              this.$refs.pageCoupon.setPages(pages);
            }
          }
        }
      });
    },

    submitCreate() {
      let current = {
        code: "coupon",
        item: this.selectItem,
      };
      this.handleClose();
      this.$emit("pageCallback", current);
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //重置搜索参数
    resetParams() {
      this.q = "";
      this.pageParams.page = 1;
      this.getList();
    },
    search() {
      this.pageParams.page = 1;
      this.getList();
    },
    checkCoupon(item) {
      this.selectItem = item;
    },
  },
};
</script>
